import { render, staticRenderFns } from "./EducationTestsArchives.vue?vue&type=template&id=010c0a94&"
import script from "./EducationTestsArchives.vue?vue&type=script&lang=js&"
export * from "./EducationTestsArchives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports